import React, { useState } from 'react';
import { useTenantStore } from '../stores/TenantStore';
import { Box, Button, Zoom } from '@mui/material';
import { useTheme } from "@mui/material";
import AppContainer from './layout/AppContainer';
import styles from './QRCodeViewer.module.css';
import IFrame from './shared/IFrame';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import QRViewerCard from './QRViewerCard';

const QRCodeViewer = ({isModal}: {isModal : boolean}) => {
    const theme = useTheme();
    const { tenant } = useTenantStore();
    const [isLinkOpen, setIsLinkOpen] = useState(false);

    const handleOpenLink = () => setIsLinkOpen(true);
    const handleCloseLink = () => setIsLinkOpen(false);
    const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            handleCloseLink()
        }
    };

    const content = (
        <div className={styles.cardContainer}>

            <div className={`${styles.card} ${isLinkOpen && styles.active}`}>
                <div
                    className={styles.front}
                    style={{
                        backgroundColor: theme.palette.background.paper,
                        backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
                    }}
                >
                    <QRViewerCard onLinkClicked={handleOpenLink} />
                </div>

                <Box
                    className={styles.backside}
                >
                    <IFrame
                        src={(tenant.urlInfo && tenant.urlInfo.url) || ""}
                    />
                    <Zoom in={isLinkOpen} timeout={500}>
                        <Button
                            variant="contained"
                            size='large'
                            startIcon={<ArrowBackIcon />}
                            onClick={handleCloseLink}
                            sx={{
                                position: 'absolute',
                                top: { xs: 6 },
                                left: 6,
                                borderColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                borderRadius: "15px"
                            }}
                        >
                            Zurück (Go Back)
                        </Button>

                    </Zoom>

                </Box>

            </div>
        </div>
    )
    return (
        isModal ?
            <div className={styles.modalInner} onClick={handleContainerClick}>
                {content}
            </div> :
            <AppContainer>
                {content}
            </AppContainer>

    );
};

export default QRCodeViewer;
